import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ClerkProvider } from '@clerk/clerk-react'
import './index.css'
import App from './App.tsx'
import { clerkNavigate } from './lib/clerkNavigation'

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
if (!publishableKey) throw new Error('VITE_CLERK_PUBLISHABLE_KEY is not set in .env.local')

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ClerkProvider publishableKey={publishableKey} afterSignOutUrl="/sign-in"
      routerPush={to => clerkNavigate(to)} routerReplace={to => clerkNavigate(to, true)}>
      <App />
    </ClerkProvider>
  </StrictMode>,
)
